import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "form", "modalTitle"]

  connect() {
    // Initialize any necessary state
  }

  openModal(event) {
    event.preventDefault()

    // Reset the form if it exists
    if (this.hasFormTarget) {
      this.formTarget.reset()
    }

    // Change the title for new record
    this.modalTitleTarget.textContent = "New Job Function"

    // Fetch the new form
    fetch("/job_functions/new", {
      headers: {
        Accept: "text/vnd.turbo-stream.html"
      }
    })
    .then(response => response.text())
    .then(html => {
      const sideSheet = document.getElementById("side_sheet")
      if (sideSheet) {
        sideSheet.innerHTML = html
      }
    })

    // Show the modal
    this.modalTarget.classList.remove("hidden")
  }

  closeModal(event) {
    event.preventDefault()
    this.modalTarget.classList.add("hidden")
    
    // Clear the side sheet content
    const sideSheet = document.getElementById("side_sheet")
    if (sideSheet) {
      sideSheet.innerHTML = ""
    }
  }

  editFunction(event) {
    event.preventDefault()

    const url = event.currentTarget.getAttribute("href")

    // Change the title for editing
    this.modalTitleTarget.textContent = "Edit Job Function"

    // Fetch the edit form
    fetch(url, {
      headers: {
        Accept: "text/vnd.turbo-stream.html"
      }
    })
    .then(response => response.text())
    .then(html => {
      const sideSheet = document.getElementById("side_sheet")
      if (sideSheet) {
        sideSheet.innerHTML = html
      }
    })

    // Show the modal
    this.modalTarget.classList.remove("hidden")
  }

  showFunction(event) {
    event.preventDefault()

    const url = event.currentTarget.getAttribute("href")

    // Change the title to show
    this.modalTitleTarget.textContent = "Job Function Details"

    // Fetch the show view
    fetch(url, {
      headers: {
        Accept: "text/vnd.turbo-stream.html"
      }
    })
    .then(response => response.text())
    .then(html => {
      const sideSheet = document.getElementById("side_sheet")
      if (sideSheet) {
        sideSheet.innerHTML = html
      }
    })

    // Show the modal
    this.modalTarget.classList.remove("hidden")
  }
} 